import script from "./EPatientDetailCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EPatientDetailCard.vue?vue&type=script&setup=true&lang=ts"

import "./EPatientDetailCard.vue?vue&type=style&index=0&id=9254f046&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9254f046"]])

export default __exports__